import {
  DEFAULT_MAX_UPLOAD_SIZE_MB,
  MAX_UPLOAD_SIZE_CEILING_MB,
} from '@lib/shared/constants/max-upload-size-bounds';

/**
 * Document upload limit in MB from
 * `NEXT_PUBLIC_MAX_UPLOAD_SIZE_MB`. Optional: unset or
 * invalid values fall back to the default, and large
 * ones clamp to the bucket ceiling. Next inlines the
 * literal `process.env.NEXT_PUBLIC_*` access at build
 * time, so changing it needs a rebuild.
 */
export function getMaxUploadSizeMb(): number {
  const raw = process.env.NEXT_PUBLIC_MAX_UPLOAD_SIZE_MB;
  const parsed = Number(raw);
  if (!raw?.trim() || !Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_MAX_UPLOAD_SIZE_MB;
  }
  return Math.min(parsed, MAX_UPLOAD_SIZE_CEILING_MB);
}
